/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meal_DessertInputs */

const en_meal_dessert = /** @type {(inputs: Meal_DessertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dessert`)
};

const de_meal_dessert = /** @type {(inputs: Meal_DessertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dessert`)
};

/**
* | output |
* | --- |
* | "Dessert" |
*
* @param {Meal_DessertInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const meal_dessert = /** @type {((inputs?: Meal_DessertInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meal_DessertInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_meal_dessert(inputs)
	return en_meal_dessert(inputs)
});